var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-wrapper"},[_vm._l((_vm.notifications),function(item,index){return [_c('NotificationCard',{key:index,attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }